module.exports = __webpack_public_path__ + "static/media/window.4623f762.svg";